import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import AuthContext from "../../../context/auth/AuthContext";
import { listPushNotifications } from "../../../services/push-notifications";
import { pushNotificationKeys } from "../queryKeys";

const usePushNotificationJobs = (filters) => {
  const { tenant } = useContext(AuthContext);
  const tenantCode = tenant?.code;

  return useQuery({
    queryKey: pushNotificationKeys.jobs(tenantCode, filters),
    queryFn: ({ signal }) => listPushNotifications({ filters, signal }),
    enabled: Boolean(tenantCode),
  });
};

export default usePushNotificationJobs;
